(function () {
    'use strict';

    angular.module('app').factory('justificationService', JustificationServiceFactory);
    
    JustificationServiceFactory.$inject = ['$rootScope'];
    function JustificationServiceFactory($rootScope) {            
        return {
            GetTitle: GetTitle,
            GetType: GetType,
            GetLevel: GetLevel,
        };

        function GetTitle(justification) {
            // Justification not provided
            if (!justification) return;
            
            const type = GetType(justification);
            const level = GetLevel(justification);
            let title = `${ type || ""}`;
            if (level) title += ` - ${level}`;

            let description = justification.ShortDescription;
            if (description) {
                if (description.length > 50) description = `${description.substr(0, 50)}...`;
                title += ` (${description})`;
            }
            return title;

        }

        function GetType(justification) {
            if (!justification || !justification.VMTypeCode || !$rootScope.codeVMTypes) return;
            
            return $rootScope.codeVMTypes.find(x => x.Key === justification.VMTypeCode).Value;
        }

        function GetLevel(justification) {
            if (!justification || !justification.VMLevelCode || !$rootScope.codeIVMLevels) return;

            return $rootScope.codeIVMLevels.find(x => x.Key === justification.VMLevelCode).Value;
        }
    }
})();
